import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { FiX } from '../../utils/icons';
import SearchSelectField, { SearchOption } from '../SearchSelectField';

interface Props {
  placeholder?: string;
  disabled?: boolean;
  options: SearchOption[];
  selected: string[];                                      // keys já escolhidas
  onChange: (next: string[]) => void;
  onAdd?: (nome: string) => Promise<SearchOption | null>;   // criação inline (botão +)
}

// Variante multi-valor do SearchSelectField: cada escolha vira um "chip" removível
// (ex.: Ramos de Atuação, Regulamentação Setorial). O campo de busca sempre volta
// vazio após uma escolha, para permitir adicionar o próximo item.
const MultiSearchSelectField: React.FC<Props> = ({ placeholder, disabled, options, selected, onChange, onAdd }) => {
  const labelOf = (key: string) => options.find(o => o.key === key)?.label || key;

  const handleSelect = (opt: SearchOption | null) => {
    if (!opt || selected.includes(opt.key)) return;
    onChange([...selected, opt.key]);
  };

  const remove = (key: string) => onChange(selected.filter(k => k !== key));

  return (
    <div>
      <SearchSelectField
        placeholder={placeholder}
        disabled={disabled}
        options={options.filter(o => !selected.includes(o.key))}
        value=""
        onSelect={handleSelect}
        onAdd={onAdd}
      />
      {selected.length > 0 && (
        <div className="d-flex flex-wrap gap-1 mt-2 p-2 border rounded bg-light">
          {selected.map(key => (
            <Badge key={key} bg="light" text="dark" className="border d-flex align-items-center gap-1">
              {labelOf(key)}
              {!disabled && (
                <Button
                  type="button"
                  variant="link"
                  className="p-0 text-danger text-decoration-none"
                  style={{ lineHeight: 1, fontSize: '0.85rem' }}
                  onClick={() => remove(key)}
                  title="Remover"
                ><FiX size={12} /></Button>
              )}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSearchSelectField;
